import { colorMapping } from '../const';
import { DeviceGroupStyles } from '../types';

export function getVariable(cssVar: string): string {
  const dark = document.querySelector('.dark');
  if (!dark) {
    const propValue = getComputedStyle(document.body).getPropertyValue(cssVar);
    return propValue;
  }
  return getComputedStyle(dark).getPropertyValue(cssVar);
}

export function assignColorsFromBreakdown(
  breakdown: { type: string; value: number }[],
): DeviceGroupStyles {
  return breakdown.reduce(
    (acc, { type }, index) => ({
      ...acc,
      [type]: colorMapping[index],
    }),
    {
      Fake: {
        bg: 'bg-purple-60',
        fill: 'fill-purple-60',
        raw: 'purple-60',
        stroke: 'stroke-purple-70',
      },
    },
  );
}
